(async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');

    const NAV_ARROWS = 'arrows';
    const NAV_PAG = 'pagination';
    const CN_AUTOPLAY = '@autoplay';
    const SP_AUTOPLAY = '--autoplay';
    const CN_NAV_DISABLED = '!disabled';

    customElements.define('slideshow-hero', class extends Core {
        elements = {
            swiper: '[data-swiper]',
            next: '[data-next]',
            prev: '[data-prev]'
        }

        render() {
            this._setSwiperProps();
            this._initSwiper();
            this._initAutoplay();
        }
        
        _initSwiper() {
            this.swiper = new Swiper(this.$swiper, this.swiperProps);
        }

        _setSwiperProps() {
            this.swiperProps = {
                loop: true
            };

            if(this.navigation == NAV_ARROWS)
                this.swiperProps.navigation = {
                    nextEl: this.$next,
                    prevEl: this.$prev,
                    disabledClass: CN_NAV_DISABLED
                }

            if(this.navigation == NAV_PAG) {
                this.swiperProps.pagination = {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                }
            }

            if(this.autoplay) {
                this.swiperProps.autoplay = {
                    delay: this.autoplay
                }
            }
        }

        _initAutoplay() {
            if(this.autoplay) {
                this.classList.add(CN_AUTOPLAY);
                this.style.setProperty(SP_AUTOPLAY, `${this.autoplay}ms`);
                
                this.swiper.on('autoplayStop', () => {
                    this.classList.remove(CN_AUTOPLAY);
                });
            }
        }

        get navigation() {
            return this.getAttribute('navigation');
        }
        get autoplay() {
            return this.getAttribute('autoplay') && +this.getAttribute('autoplay');
        }
    })
})();